export default __webpack_public_path__ + "static/media/HowItWorks-03.d67f4124.jpg";